module.exports = __webpack_public_path__ + "assets/img/tx180_2.f86f7f6e.jpg";